<template>
    <div class="container">
        <van-nav-bar leftText leftArrow @click-left="backGo" class="query-header headerbar">
            <div class="bh bstart query-title" slot="title">
                <van-field
                    v-model="queryText"
                    class="input-query"
                    clearable
                    maxlength="20"
                    placeholder="请输入关键词查询"
                >
                    <div slot="right-icon" class="ico-query bg-contain"></div>
                </van-field>
            </div>
            <van-button @click="onQueryClick(queryText)" class="btn btn-text" slot="right">
                <div class="fz_30">{{queryBtnText}}</div>
            </van-button>
        </van-nav-bar>
        <div class="topbar-container group-panel">
            <!--具体分类-->
            <div class="list-panel group-container" ref="listScroll">
                <div>
                    <div class="line"></div>
                    <div class="history">
                        <div class="bh bstart local-list">
                            <GroupButton
                                title="GPS定位"
                                :data="gpsData"
                                icoCls="ico-location bg-contain"
                                class="b1"
                                @btnClick="onItemClick"
                            ></GroupButton>
                            <GroupButton
                                title="当前定位"
                                :data="localData"
                                class="b1"
                                @btnClick="onItemClick"
                            ></GroupButton>
                        </div>
                        <GroupButton
                            title="历史定位"
                            :data="historyData.data"
                            :isDel="true"
                            @delClick="onDelClick"
                            @btnClick="onItemClick"
                            class="big-list"
                        ></GroupButton>
                    </div>
                    <!-- 具体分类 -->
                    <div v-for="(item,index) in locationList" :key="index" class="big-list fz_30">
                        <div class="title">{{item.initialsChar}}</div>
                        <div
                            v-for="(item,index) in item.locations"
                            :key="index"
                            @click="onItemClick(item)"
                            class="list-item"
                        >
                            <div class="item shadow-bg">
                                <div class="content">{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--分类列表-->
            <div class="menu-panel" ref="menuScroll">
                <div class="bv bc menu-panel-el">
                    <div
                        class="menu-item fz_28 tc"
                        :class="{'activate':activateIndex === 0}"
                        @click="selectMenu(0)"
                    >历史</div>
                    <div
                        class="menu-item fz_28 tc"
                        :class="{'activate':activateIndex === index+1}"
                        v-for="(item,index) in locationList"
                        :key="index"
                        @click="selectMenu(index+1)"
                    >{{item.initialsChar}}</div>
                </div>
            </div>
            <div class="query-container group-container" :class="[isQuery?'zIndex':'']">
                <div class="scrollbar-container shop-info">
                    <div class="line"></div>
                    <div class="list-empty fz_30 tc" v-if="!queryList.length">抱歉，未找到相关位置</div>
                    <div
                        class="list-item fz_30"
                        v-for="(item,index) in queryList"
                        :key="index"
                        @click="onItemClick(item)"
                    >{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { group } from "@/mixin/group";
import GroupButton from "@/components/btn/Group";
import cache from "@/utils/cache";
import { routeCache } from "@/mixin/cache";
export default {
    mixins: [group, routeCache],
    components: { GroupButton },
    name: "LocationHome",
    data() {
        return {
            isQuery: false,
            historyData: {
                data: [],
                key: "locationHistory"
            },
            localData: [],
            gpsData: [],
            queryText: "",
            queryList: []
        };
    },
    created() {
        const me = this,
            params = me.getCache();
        me.localData = [{ name: params.local }];
        me.gpsData = [{ name: params.gps }];
        me.$store.dispatch("locationList");
        cache.load(me.historyData);
        if (me.locationList && me.locationList.length) {
            me.initGroup();
        }
    },
    computed: {
        locationList() {
            return this.$store.state.locationList.filter(item => {
                return item.locations.length;
            });
        },
        queryBtnText() {
            return this.isQuery ? "取消" : "查询";
        }
    },
    watch: {
        locationList(v) {
            // DOM已经更新
            this.initGroup();
        }
    },
    methods: {
        onQueryClick(v) {
            const me = this;
            if (v && !me.isQuery) {
                me.isQuery = true;
                const list = [];
                // 根据关键词循环遍历过滤
                me.locationList.forEach(item => {
                    item.locations.forEach(item => {
                        if (item.name.indexOf(v) > -1) {
                            list.push(item);
                        }
                    });
                });
                me.queryList = list;
            } else {
                me.isQuery = false;
                me.queryText = "";
            }
        },
        onDelClick() {
            this.dialog
                .confirm({
                    title: "提示",
                    message: "确定删除历史定位？"
                })
                .then(() => {
                    cache.removeAll(this.historyData);
                });
        },
        onItemClick(item) {
            cache.push(this.historyData, item);
            this.$store.state.localValue = item.name;
            this.$router.go(-1);
        }
    }
};
</script>
<style scoped lang="scss">
/deep/.ico-location {
    width: 20px;
    height: 25px;
    margin-right: 12px;
}
.line {
    background: #f1f2f3;
}
.group-panel {
    .group-container {
        height: calc(100% - #{$topbar-container-top});
    }
    .menu-panel {
        position: absolute;
        right: 10px;
        top: $topbar-container-top + 40px;
        z-index: 1;
        .menu-panel-el {
            height: 100%;
            .menu-item {
                width: 40px;
                line-height: 1em;
                padding: 7.5px 20px;
                &.activate {
                    color: #ff9a2b;
                }
            }
        }
    }
    .list-panel {
        width: 100%;
        overflow: hidden;
        color: #333;
        background-color: #fff;
        position: absolute;
        z-index: 1;
        .history {
            padding: 0 60px 60px 0;
            .local-list {
                /deep/.group-list-item {
                    max-width: 100%;
                }
            }
        }
        .title {
            height: 60px;
            line-height: 60px;
            padding-left: 30px;
            background: #f1f2f3;
        }
        .item {
            padding: 30px;
        }
    }
    .query-container {
        z-index: 0;
        position: absolute;
        width: 100%;
        background: #f1f2f3;
        .list-item {
            background: #fff;
            padding: 30px;
            color: #333;
        }
        .list-empty {
            background: #fff;
            padding: 60px 0 321px 0;
        }
    }
}
.zIndex {
    z-index: 4 !important;
}
</style>